'use client'

import { KeyboardEvent } from 'react'
import { Cell, Icon, Spacer, Text } from '@vinted/web-ui'
import { ChevronRight24, Gift24 } from '@vinted/monochrome-icons'

import { KeyboardKey, onA11yKeyDown } from '@marketplace-web/vendor-abstractions/web-ui-util'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

type Props = {
  isVisible: boolean
  isMultipleOffers: boolean
  onClick: () => void
}

const OfferBanner = ({ isVisible, isMultipleOffers, onClick }: Props) => {
  const translate = useTranslate('vinted_ads_network.digital_label_offer')

  if (!isVisible) return null

  const handleKeyDown = (event: KeyboardEvent) =>
    onA11yKeyDown(event, { keys: [KeyboardKey.Enter, KeyboardKey.Space] }, onClick)

  const multiKey = isMultipleOffers ? 'multiple' : 'single'

  return (
    <>
      <Spacer size="large" />
      <div
        className="digital-label-offer__ad-banner"
        role="button"
        onClick={onClick}
        onKeyDown={handleKeyDown}
        tabIndex={0}
      >
        <Cell
          theme="transparent"
          prefix={<Icon name={Gift24} color="greyscale-level-2" />}
          body={
            <Text as="span" text={translate(`banner.${multiKey}`)} type="title" theme="amplified" />
          }
          suffix={<Icon name={ChevronRight24} color="greyscale-level-2" />}
          aria={{
            'aria-label': translate(`a11y.actions.click_on_banner.${multiKey}`),
          }}
        />
      </div>
    </>
  )
}

export default OfferBanner
